<template>
	<fragment>
		<HeadingSVG class="unfixed" imgName="big-bummer" altText="Big Bummer" v-if="!showingInvoice" />
		<transition name="fade-slide-up-out" mode="out-in">
			<div class="wysiwyg-content desciption" v-html="description"
				v-if="!showingInvoice" key="description" />
			<div class="invoice-wrapper" v-else key="invoice">
			<Accordion class="eob-section">
				<fragment slot="header" class="header">
					<span class="label">{{ ui.total_cost }}:</span>
					<span class="cost">{{ totalCost | currency }}</span>
				</fragment>
				<fragment slot="body">
					<PricedItem v-for="({ title, cost }) in damages" :key="title" :title="title" :amount="cost" />
				</fragment>
			</Accordion>
			<Accordion class="eob-section">
				<fragment slot="header">
					<span class="label">{{ ui.insurance_pays }}:</span>
					<span class="cost">{{ insurancePays | currency }}</span>
				</fragment>
				<fragment slot="body">
					<div class="group" v-for="({ title, prices, messages }, id) in insured" :key="id">
						<h6 v-if="displayTitle(title, prices)">{{ title }}</h6>
						<div class="line-items" v-for="cost in prices" :key="cost.label">
							<PricedItem :key="cost.label" :title="cost.label" :amount="cost.cost" v-if="cost.cost > 0" />
						</div>
						<h6 v-for="message in messages" :key="message">{{ message }}</h6>
					</div>
				</fragment>
			</Accordion>
			<Accordion class="eob-section you-pay-section">
				<fragment slot="header">
					<span class="label">{{ ui.you_pay }}:</span>
					<span class="cost">{{ youPay | currency }}</span>
				</fragment>
				<fragment slot="body">
					<div class="group" v-for="({ title, prices, messages }, id) in uninsured" :key="id">
						<h6 v-if="displayTitle(title, prices)">{{ title }}</h6>
						<div class="line-items" v-for="cost in prices" :key="cost.label">
							<PricedItem :key="cost.label" :title="cost.label" :amount="cost.cost" v-if="cost.cost > 0" />
						</div>
						<h6 class="message" v-for="message in messages" :key="message">{{ message }}</h6>
					</div>
				</fragment>
			</Accordion>
			</div>
		</transition>
		<MarqueeButton class="big-bummer" :action="advance">{{ button_text }}</MarqueeButton>
	</fragment>
</template>

<script>
import Accordion from '@/components/base/Accordion';
import HeadingSVG from '@/components/base/HeadingSVG';
import MarqueeButton from "@/components/base/MarqueeButton";
import PricedItem from '@/components/base/PricedItem';
import { mapState, mapGetters } from "vuex";

export default {
	name: 'Big',
	components: {
		Accordion,
		HeadingSVG,
		MarqueeButton,
		PricedItem,
	},
	props: {
		button_text: {
			type: String,
			required: true,
		},
		damages: {
			type: Array,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		id: {
			type: Number,
		},
		insurance_type: {
			type: Number,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
	},
	data: () => ({
		showingInvoice: false,
	}),
	computed: {
		...mapState({
			insured: (state) => state.game.bummers.active.big.insured,
			uninsured: (state) => state.game.bummers.active.big.uninsured,
			ui: (state) => state.global.api.data.ui.bummers.big,
		}),
		...mapGetters("game/bummers/active/big", {
			insurancePays: "insurancePays",
			youPay: "youPay",
		}),
		totalCost() {
			return this.damages.reduce((total, damage) => total + damage.cost, 0);
		},
	},
	methods: {
		advance() {
			if (!this.showingInvoice) {
				this.showingInvoice = true;
				this.$store.dispatch("sound/fx/play", { id: "big_bummer_eob" });
			} else {
				this.$parent.complete();
				this.$store.dispatch("sound/fx/play", { id: "button_generic" });
			}
		},
		displayTitle(title, prices) {
			return title && prices.some(({ cost }) => cost > 0);
		},
	},
	mounted() {
		this.$store.dispatch(`game/bummers/active/big/initialize`);
		this.$store.dispatch("sound/fx/play", { id: "big_bummer" });
		this.$store.dispatch("global/analytics/trackEvent", { ec: "InGame", el: "BigBummer", ea: `${this.title}` });
	},
};
</script>

<style lang="scss" scoped>
	.heading.heading-svg {
		@include mobile { margin: 0 0 20px; }
	}

	.invoice-wrapper {
		width: 100%;

		@include tablet { width: 80%; }
	}

	.eob-section {
		margin: .25em 0;
		width: 100%;

		::v-deep .accordion-body {
			width: 85%;

			@include desktop { width: 75%; }
		}
	}

	.label {
		text-transform: uppercase;

		@include mobile { text-align: left; }
	}

	.cost {
		margin-left: auto;
		font-size: $font-size-xxl;

		@include mobile { font-size: $font-size-lg; }
	}

	h6 {
		text-align: left;
		font-size: $font-size-sm;
		margin-bottom: 10px;
	}

	.message {
		text-align: center;
		font-size: $font-size-md;
		color: $primary-color-extra-light;
		margin: 20px 0 0;
	}

	.deductible-meter-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.deductible-meter {
		width: 100%;
		text-align: right;
	}

	.you-pay-section {
		margin-bottom: 1rem;

		.cost { color: $primary-color-extra-light; }
	}

	.marquee-btn { margin: 20px 0 0; }
</style>
